import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Federal Spending Intelligence",
  published_at: "2026-03-17",
  summary: "Search 167 million federal awards, explore recipient profiles and agency dashboards, and let the AI assistant answer spending questions in plain language.",
  tags: ["Integrations", "AI"],
  draft: false
};
export const sections = [{
  id: "federal-spending-intelligence",
  label: "Federal Spending Intelligence"
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "federal-spending-intelligence",
      tabIndex: "-1",
      children: "Federal Spending Intelligence"
    }), "\n", _jsx(_components.p, {
      children: "Sweetspot now includes a complete federal spending research layer powered by USASpending, FPDS, and SAM data. Search recipients, explore award histories, analyze agency spending patterns, and ask the AI assistant analytical questions, all without leaving the platform."
    }), "\n", _jsx(_components.h3, {
      children: "Recipient Search"
    }), "\n", _jsx(_components.p, {
      children: "Find federal contractors and grantees by name, UEI, DUNS, or CAGE code. Filter by socioeconomic certifications (8(a), HUBZone, WOSB, SDVOSB, and more), location, NAICS codes, awarding agency, and spending range. Export results to Excel or CSV."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/changelog/2026-03-09-usaspending/recipient-search.png",
        alt: "Recipient search with certification and location filters"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Recipient Profiles"
    }), "\n", _jsx(_components.p, {
      children: "Each recipient has a dedicated profile showing total obligations, award counts, top awarding agencies, product service code breakdown, and a cash flow chart that visualizes disbursement patterns over time. Navigate parent and subsidiary relationships to understand company hierarchies."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "d05ef295-8cc7-49b6-82a2-91a3ed72ca38"
    }), "\n", _jsx(_components.h3, {
      children: "Award Details"
    }), "\n", _jsx(_components.p, {
      children: "Drill into any contract or grant to see the full transaction history, obligation timeline, period of performance, sub-awards, and linked solicitations. Awards connect back to active Sweetspot opportunities so you can see current and upcoming recompetes."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "7af8230d-1440-4ebc-baa1-a2c036fe2803"
    }), "\n", _jsx(_components.h3, {
      children: "Agency Dashboards"
    }), "\n", _jsx(_components.p, {
      children: "Agency pages show spending trends across fiscal years, award type mix, set-aside utilization against government goals, top recipients, NAICS and PSC breakdowns, and geographic distribution of spending."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "a3fbd2af-89d5-45d8-a8d5-1daafb496603"
    }), "\n", _jsx(_components.h3, {
      children: "AI Award Search"
    }), "\n", _jsx(_components.p, {
      children: "Ask analytical questions in plain language. Try \"Show me SDVOSB IT contracts over $5M awarded by the VA in the last two years\" and the assistant queries across 167 million awards to surface results, charts, and insights directly in chat."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "99b8a7de-fa7b-47ef-b5c5-27c950b49e9e"
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Performance (2)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Image generation now has fallback support with improved parallel generation UI"
        }), "\n", _jsx(_components.li, {
          children: "Proposal writer has model fallbacks to reduce failures during high traffic"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Bug Fixes (2)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Fixed compliance matrix visibility and misaligned shredding status indicators"
        }), "\n", _jsx(_components.li, {
          children: "Fixed minor layout issues in the chat side panel"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
